
import React from "react";
import Bookpanel from '../Components/Dashboard/Resource-Center/Bookpanel';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthBookpanel = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Bookpanel /> : <SessionTimeoutRedirect />
}
export default AuthBookpanel;


